import { IdNameObjectItem } from './id-name-item'

export type RoomCategory = IdNameObjectItem<number>

export const roomCategories: RoomCategory[] = [
  { id: 1, name: $localize`Living` },
  { id: 2, name: $localize`Dining` },
  { id: 3, name: $localize`Bedroom` },
  { id: 4, name: $localize`Bathroom` },
  { id: 5, name: $localize`Kitchen` },
  { id: 6, name: $localize`Pool` },
  { id: 7, name: $localize`Outside` },
  { id: 8, name: $localize`Garden` },
  { id: 9, name: $localize`Patio` },
  { id: 10, name: $localize`Gym` },
  { id: 11, name: $localize`Sports` },
  { id: 12, name: $localize`Location` },
  { id: 13, name: $localize`Utility` },
  { id: 14, name: $localize`Garage` },
  { id: 15, name: $localize`Storage` },
  { id: 16, name: $localize`Laundry` },
  { id: 17, name: $localize`Other` },
]
